@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="safetypoint" [data]="safetypointList" [columnsdef]="columnsdefMain"
    [importButton]="false" [pageSize]="20" [editButton]="permissionService.SafetyPointSchreiben"
    [createButton]="permissionService.SafetyPointSchreiben" [deleteButton]="permissionService.SafetyPointLoeschen"
    [(selectedElement)]="selectedSafetyPoint" (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event)">

    <lib-dba-mat-table-select [filter]="debitorFilter" [label]="language.debitor | translationPipe"
        labelProperty="Name" [list]="debitorList" [(value)]="selectedDebitor" [translate]="false"
        (valueChange)="filterStandort()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="standortFilter" [label]="language.Standort| translationPipe"
        labelProperty="Bezeichnung" [list]="standortfilteredList" [(value)]="selectedStandort" [translate]="false"
        (valueChange)="filterObjekte()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="objektFilter" [label]="language.objekt | translationPipe"
        labelProperty="Bezeichnung" [list]="objektfilteredList" [(value)]="selectedObjekt" [translate]="false"
        (valueChange)="filterroofarea()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="roofareaFilter" [label]="language.roofarea | translationPipe"
        labelProperty="Bezeichnung" [list]="roofareafilteredList" [(value)]="selectedRoofarea" [translate]="false"
        (valueChange)="filtersicherungssystem()" >
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="sicherungssystemFilter" [label]="language.Sicherungssystem | translationPipe"
        labelProperty="Bezeichnung" [list]="SicherungssystemfilteredList" [(value)]="selectedSicherungssystem" [translate]="false">
    </lib-dba-mat-table-select>
    
  <lib-dba-mat-table-button title= "Drucken" [disabled]="!selectedSafetyPoint" (click)="Berichtdrucken($event)">
  </lib-dba-mat-table-button>
</lib-dba-mat-table>